import { Ref } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

export type GetMyPushData = {
	push_data: PushData[];
};
type PushData = {
	push_send_status_pk: number;
	push_send_status_receiver_id: string;
	push_send_status_enrollment_date: string;
	push_send_status_reservation_date: null;
	push_send_status_send_date: string;
	push_send_status_state: string;
	push_send_status_confirm_yn: number;
	push_pk: number;
	push_send_target: string;
	push_send_type: string;
	push_send_division: string;
	push_use_yn: number;
	push_title: string;
	push_content: string;
	push_url: string;
	push_send_date: string;
	push_reservation_date: null;
	push_enrollment_date: string;
	push_modifying_date: null;
	administrator_pk: number;
	master_pk: null;
};
export const useGetMyPushApi = () => {
	const url = '/v1/front/getMyPush';
	return useQuery<AxiosResponse, AxiosError, GetMyPushData>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data?.data,
		enabled: false,
	});
};

export type UpdatePushParams = {
	member_push_token: string;
};
export const useUpdatePushTokenApi = () => {
	const url = '/v1/front/updatePushToken';
	return useMutation<AxiosResponse, AxiosError, UpdatePushParams>({
		mutationFn: (data: UpdatePushParams) => api.post(url, data),
	});
};

export type CallbackMobileDataType = {
	provider: string | number;
	uid: string | number;
};

type CallbackMobileResType = CommonResType<{
	access_token: string;
}>;

export const useCallbackMobileApi = () => {
	const url = '/callbackMobile';
	return useMutation<AxiosResponse<CallbackMobileResType>, AxiosError, CallbackMobileDataType>({
		mutationFn: (data: CallbackMobileDataType) => api.post(url, data),
	});
};

export type RequestTSignParams = {
	token: string | number;
	device_type?: string;
};

type RequestTSignResData = CommonResType<{
	refresh_token: string;
	access_token: string;
	basic_info_yn: string | number;
	member_join_path: string;
	member_name: string;
	member_nickname: string;
	group_pk: number | null;
	group_sp: number | null;
}>;

export const useRequestTSignApi = () => {
	const url = '/v1/front/requestTSign';
	return useMutation<AxiosResponse<RequestTSignResData>, AxiosError, RequestTSignParams>({
		mutationFn: (data: RequestTSignParams) => api.post(url, data),
	});
};

export type ConfirmPushParams = {
	push_send_status_pk: number;
};

export type ConfirmPushData = CommonResType;
export const useConfirmPushApi = (params: Ref<ConfirmPushParams>) => {
	const url = '/v1/front/confirmPush';
	return useQuery<AxiosResponse, AxiosError, ConfirmPushData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
		enabled: false,
	});
};
